gz-enum-filter {
  --dropdown-width: 400px;
}

.rule-sets-form {
  padding: 0 calc(2 * var(--spacer));
  &--row {
    padding: 10px 0 var(--spacer) 0;
    display: inline-flex;
  }

  &--field {
    margin-right: calc(2 * var(--spacer));
    position: relative;
    height: calc(4 * var(--spacer));

    gz-enum-filter {
      width: 100%;
    }
  }
}

#rule-sets-notice {
  padding: calc(2 * var(--spacer)) 0;
}

.grid-view {
  height: 400px;
}
